import { playSound, Sound } from '~/assets/sounds';
import { TextLabel } from '../TextLabel';
import {
	StyledContainer,
	StyledImage,
	StyledInfoContainer,
	StyledLastMessage,
	StyledLeftContainer,
	StyledNameContainer,
	StyledNewMessagesCounter,
	StyledTime,
} from './AppMessageDialogItem.styled';

const AppMessageDialogItem = ({
	name,
	online,
	time,
	unread,
	active,
}: {
	name: string;
	online?: boolean;
	time: string;
	unread?: boolean;
	active?: boolean;
}) => {
	return (
		<StyledContainer
			$active={active}
			onMouseEnter={() => playSound(Sound.LinkCursor)}
			onClick={() => {
				playSound(Sound.ClickButton);
			}}
		>
			<StyledLeftContainer>
				<StyledImage $online={online} />
				<StyledInfoContainer>
					<StyledNameContainer>
						<TextLabel>{name}</TextLabel>
						{online && <div className={'dot'} />}
					</StyledNameContainer>
					<StyledLastMessage $unread={unread}>
						Привет, ну как там дела? Когда уже релиз то будет у нас на сервере,
						а то уже заебался ждать когда он блять произойдёт
					</StyledLastMessage>
				</StyledInfoContainer>
			</StyledLeftContainer>
			{unread && (
				<StyledNewMessagesCounter>
					<TextLabel>5</TextLabel>
				</StyledNewMessagesCounter>
			)}
			{!unread && <StyledTime>{time}</StyledTime>}
		</StyledContainer>
	);
};

export { AppMessageDialogItem };
